module.exports = __webpack_public_path__ + "static/img/Retum-z@2x.63fe530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/Retum-z@2x.png
// module id = Ioyr
// module chunks = 54